import { render, staticRenderFns } from "./CarrierCards.vue?vue&type=template&id=3b1b0e82&"
import script from "./CarrierCards.vue?vue&type=script&lang=js&"
export * from "./CarrierCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports